import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import { TextField } from '@material-ui/core';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
// import LoadderButton from '../../Layouts/LoadderButton';
import AuthApi from '../../Services/Authapi';
import swal from "sweetalert";
// import Paper from '@material-ui/core/Paper';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import AuthCheckComponent from '../../Layouts/Token';
// import { SignalCellularNull } from '@material-ui/icons';
// import Authapi from '../../Services/Authapi';
// import swal from 'sweetalert';
// import InputLabel from '@material-ui/core/InputLabel';
// import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
// import { now } from 'moment';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

const useStyles = makeStyles((theme) => ({
    uploadArea: {
        width: '100%',
        minHeight: '100px',
        border: `2px dashed ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.2)' : '#cbd5e1'}`,
        borderRadius: '1rem',
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#f8fafc',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        padding: theme.spacing(1),
        '&:hover': {
            backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#f1f5f9',
            borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.4)' : '#94a3b8',
        },
    },
    uploadAreaActive: {
        backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.15)' : '#ffffff',
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 4px ${theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(30, 41, 59, 0.1)'}`,
    },
    fileInput: {
        display: 'none',
    },
}));


const iniEvent = {
    upcomingEventName: "",
    upcomingEventdate: "",
    description: "",
    image: null,
    event_Id: 0,
}


const EditTicket = (props) => {
    const classes = props;
    const styles = useStyles();
    const [dragActive, setDragActive] = useState(false);
    const [eventValues, setEventsValues] = useState(iniEvent);
    // const [selectedImages, setSelectedImages] = useState({ image: null });
    // const [stringImages, setStringImages] = useState({ images: [] });
    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);


    useEffect(() => {
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEventsValues({ ...eventValues, [name]: value });

        if (name === "upcomingEventdate") {
            const selectedDate = moment(value, "YYYY-MM-DD");
            const dayOfWeek = selectedDate.day();

            if (dayOfWeek === 6 || dayOfWeek === 0) { // 6 = Saturday, 0 = Sunday
                swal({
                    title: "Invalid Date",
                    text: "Weekends are not allowed",
                    icon: "error",
                });
            }
        }
    };


    function dateDiffInDays(startDate, endDate) {
        // round to the nearest whole number
        return Math.round((endDate - startDate) / (1000 * 60 * 60 * 24));
    }

    const dsp = dateDiffInDays(new Date(), new Date(eventValues.upcomingEventdate))


    const validate = (values) => {
        let errors = {};
        const regex = /^[a-zA-Z]/;
        const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

        if (!values.upcomingEventName) {
            errors.upcomingEventName = "Cannot be blank";
        } else if (!regex.test(values.upcomingEventName)) {
            errors.upcomingEventName = "Invalid upcomingEventName format";
        }

        if (!values.upcomingEventdate) {
            errors.upcomingEventdate = "Cannot be blank";
        } else if (!dateR.test(values.upcomingEventdate)) {
            errors.upcomingEventdate = "Invalid upcomingEventdate format";
        } else {
            const selectedDate = moment(values.upcomingEventdate, "YYYY-MM-DD");
            const dayOfWeek = selectedDate.day();
            if (dayOfWeek === 6 || dayOfWeek === 0) {
                errors.upcomingEventdate = "Weekends are not allowed";
            } else if (dsp < 0) {
                errors.upcomingEventdate = "You can choose only current and future dates";
            }
        }

        if (!values.description) {
            errors.description = "Cannot be blank";
        } else if (!regex.test(values.description)) {
            errors.description = "Invalid description format";
        }
        return errors;
    };

    const getEventData = async () => {
        let Id = props.history.location.pathname.split('/')[props.history.location.pathname.split('/').length - 1];
        let upcomingEvent = await AuthApi.singleUpcomingEvent(Id);
        let event_Id = Id
        let upcomingEventName = (upcomingEvent.status === true && upcomingEvent.data && upcomingEvent.data.name && (upcomingEvent.data.name !== null || upcomingEvent.data.name !== false)) ? upcomingEvent.data.name : null;
        let upcomingEventdate = (upcomingEvent.status === true && upcomingEvent.data && upcomingEvent.data.date) ? upcomingEvent.data.date : null;
        let description = (upcomingEvent.status === true && upcomingEvent.data && upcomingEvent.data.description) ? upcomingEvent.data.description : null;
        let image = (upcomingEvent.status === true && upcomingEvent.data && upcomingEvent.data.image) ? upcomingEvent.data.image : null;
        setEventsValues({
            upcomingEventName: upcomingEventName,
            upcomingEventdate: upcomingEventdate,
            description: description,
            image: image,
            event_Id: event_Id,
        });
    }

    // useEffect(
    //     () =>
    //         setTimeout(
    //             () => getEventData(),
    //             500), []);


    useEffect(() => {
        setTimeout(() => getEventData(), 500);
    }, []);


    const handleFileUpload = async (file) => {
        const postData = new FormData();
        postData.append('file', file);
        let updaImg = await AuthApi.uploadEventImg(postData);
        if (updaImg && updaImg.status === true) {
            setEventsValues({
                ...eventValues,
                image: updaImg.data.image_url,
            })
        }
    }

    const uploadSingleFile = (e) => {
        if (e.target.files && e.target.files[0]) {
            handleFileUpload(e.target.files[0]);
        }
    }

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFileUpload(e.dataTransfer.files[0]);
        }
    };


    const removeImg = async (e) => {
        let imageLink = eventValues.image;
        imageLink = imageLink.substr(imageLink.indexOf('/', 7) + 1)
        let remImg = await AuthApi.upcomingdeleteImg(imageLink);
        if (remImg && remImg.status === true) {
            // setEventsValues({
            //     // ...setEditValues,
            //     image: null,
            // })
            getEventData()
        } else {
        }
        // setEditValues({
        //     photo: null,
        //     uploadedImgName: null
        // })
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validate(eventValues);
        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            setIsSubmitting(true);
        } else if (errors.upcomingEventdate) {
            swal({
                title: "Invalid Date",
                text: errors.upcomingEventdate,
                icon: "error",
            });
        }
    };

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmitting) {
            editUpComingEvent();
        }
    }, [formErrors]);


    const editUpComingEvent = async (id) => {
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            icon: "info",
        });
        try {
            let status = await AuthApi.updateUpcomingEvent(eventValues, eventValues.event_Id);
            swal.close();
            if (status && status.status === true) {
                swal("Success", "Event updated successfully", "success").then(() => {
                    props.history.push('/upcoming-event');
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: status && status.message ? status.message : "Something went wrong, Please try later!"
                })
            }
        } catch (error) {
            console.error("Error updating role:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    }

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <Card className={classes.root} style={{ marginBottom: '3%' }}>
                            <CardContent>
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Upcoming Events"
                                    primaryPageLink="/upcoming-event"
                                    isSecondaryPage={true}
                                    secondaryPageName="edit" />
                            </CardContent>
                        </Card>
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={12}>
                                <Card className={classes.root}>
                                    <CardContent>
                                        <Typography variant="h2" className="common-form-page-title">Edit Upcoming Event</Typography>
                                        <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit} >
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="upcomingEventName"
                                                        name="upcomingEventName"
                                                        label="UpcomingEvent-Name"
                                                        variant="outlined"
                                                        error={formErrors.upcomingEventName && true}
                                                        value={(eventValues && eventValues.upcomingEventName !== null) ? eventValues.upcomingEventName : null}
                                                        onChange={handleChange}
                                                        className={formErrors.upcomingEventName && "input-error"}
                                                    />

                                                    {formErrors.upcomingEventName && (
                                                        <span className="error">{formErrors.upcomingEventName}</span>
                                                    )}
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="date"
                                                        variant="outlined"
                                                        label="Upcoming-Event-Date"
                                                        name="upcomingEventdate"
                                                        type="date"
                                                        error={formErrors.upcomingEventdate && true}
                                                        value={(eventValues && eventValues.upcomingEventdate !== null) ? eventValues.upcomingEventdate : null}
                                                        onChange={handleChange}
                                                        inputProps={{
                                                            min: moment().add(1, 'days').format('YYYY-MM-DD')
                                                        }}
                                                    />
                                                    {formErrors.upcomingEventdate && (
                                                        <span className="error">{formErrors.upcomingEventdate}</span>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={5} >
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        rows={3}
                                                        variant="outlined"
                                                        label="Add Details"
                                                        id="description"
                                                        name="description"
                                                        error={formErrors.description && true}
                                                        className={`${classes.textField || ''} ${formErrors.description ? "input-error" : ""}`}
                                                        // rowsMin={3}
                                                        value={(eventValues && eventValues.description !== null) ? eventValues.description : ""}
                                                        onChange={handleChange}
                                                    />
                                                    {formErrors.description && (
                                                        <span className="error">{formErrors.description}</span>
                                                    )}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <div
                                                        className={`${styles.uploadArea} ${dragActive ? styles.uploadAreaActive : ''}`}
                                                        onDragEnter={handleDrag}
                                                        onDragLeave={handleDrag}
                                                        onDragOver={handleDrag}
                                                        onDrop={handleDrop}
                                                        onClick={() => document.getElementById('contained-button-file').click()}
                                                    >
                                                        <input
                                                            accept="image/*"
                                                            className={styles.fileInput}
                                                            id="contained-button-file"
                                                            type="file"
                                                            onChange={uploadSingleFile}
                                                        />
                                                        {eventValues.image && (
                                                            <img
                                                                src={eventValues.image}
                                                                alt="Event image"
                                                                style={{
                                                                    width: "100px",
                                                                    height: "100px",
                                                                    marginBottom: '8px',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '8px',
                                                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                                                                }}
                                                            />
                                                        )}
                                                        <Typography variant="subtitle2" className="common-upload-drop-title">
                                                            {eventValues.image ? "Change File" : "Drag & Drop your file here"}
                                                        </Typography>
                                                        <Typography variant="caption" className="common-upload-drop-caption">
                                                            or
                                                        </Typography>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            component="span"
                                                            size="small"
                                                            startIcon={<CloudUploadIcon />}
                                                            className="common-upload-drop-button"
                                                        >
                                                            Upload a file
                                                        </Button>
                                                    </div>
                                                    {eventValues.image && (
                                                        <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                            <Button onClick={(e) => removeImg(e)} size="small" color="secondary">
                                                                Remove Image
                                                            </Button>
                                                        </div>
                                                    )}
                                                </Grid>
                                            </Grid>



                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={4} style={{ display: 'flex' }}>
                                                    <Button type="submit" style={{ marginTop: "10px", textTransform: 'none' }} variant="contained" color="primary">Edit</Button>
                                                    <Button type="button" className="btn-cancel" style={{ marginTop: "10px", textTransform: 'none' }} onClick={(e) => { e.preventDefault(); props.history.push('/upcoming-event') }}>Cancel</Button>
                                                </Grid>
                                                <Grid item xs={4}></Grid>
                                                <Grid item xs={4}></Grid>
                                            </Grid>
                                        </form>

                                    </CardContent>
                                </Card>
                            </Grid >
                            <Grid item xs={6}></Grid>
                        </Grid >
                    </div >
                } />
            < Footer />
        </div >
    )
}

export default EditTicket;
